// extracted by mini-css-extract-plugin
export default {"risks":"style_risks__mMvhG","programs":"style_programs__m1lgZ"};